import { useEntity } from '@backstage/plugin-catalog-react';
import {
  EntitySonarqubeContent,
  isSonarQubeAvailable,
} from '@mercedes-benz/plugin-sonarqube-wrapper';
import { makeStyles } from 'tss-react/mui';
import { getColors, typography } from '@mercedes-benz/odp-theme-v2';
import InsightsIcon from '@mui/icons-material/Insights';
import { PluginTabWrapper } from './PluginTabWrapper';

const useStyles = makeStyles()(theme => {
  const c = getColors(theme.palette.mode);
  const isLight = theme.palette.mode === 'light';
  const fgAlpha = (a: number) =>
    isLight ? `rgba(0, 0, 0, ${a})` : `rgba(255, 255, 255, ${a})`;
  return {
    emptyState: {
      padding: 48,
      minHeight: 400,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 12,
      textAlign: 'center',
    },
    iconWrapper: {
      width: 56,
      height: 56,
      borderRadius: '50%',
      background: 'rgba(0, 120, 214, 0.1)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& svg': {
        width: 28,
        height: 28,
        color: c.primary.main,
      },
    },
    emptyTitle: {
      fontFamily: typography.fontFamilyCorpoSText,
      color: c.text.primary,
      fontWeight: 600,
      fontSize: '1.1rem',
      margin: 0,
    },
    emptySubtitle: {
      fontFamily: typography.fontFamilyCorpoSText,
      color: fgAlpha(0.45),
      fontSize: '0.875rem',
      margin: 0,
    },
  };
});

export const SonarQubeTab = () => {
  const { classes } = useStyles();
  const { entity } = useEntity();

  if (!isSonarQubeAvailable(entity)) {
    return (
      <PluginTabWrapper>
        <div className={classes.emptyState}>
          <div className={classes.iconWrapper}>
            <InsightsIcon />
          </div>
          <h3 className={classes.emptyTitle}>
            No SonarQube project configured
          </h3>
          <p className={classes.emptySubtitle}>
            Add a <code>sonarqube.org/project-key</code> annotation to enable
            code quality analysis for this component.
          </p>
        </div>
      </PluginTabWrapper>
    );
  }

  return (
    <PluginTabWrapper>
      <EntitySonarqubeContent />
    </PluginTabWrapper>
  );
};
